import "./Services.module.css";
import Header from "@/reusable_sections/Header";
import ServicesHero from "./sections/ServicesHero";
import ServicesShowcase from "./sections/ServicesShowcase";
import ContactAndSidebarForm from "./sections/ContactAndSidebarForm";
import Footer from "@/reusable_sections/Footer";
export default function ServicesPage() {
  return <div>
      <Header />
      <ServicesHero />
      <ServicesShowcase />
      <ContactAndSidebarForm />
      <Footer />
    </div>;
}